class ValidationError extends Error {
    constructor(errors) {
        super('Validatie mislukt!');
        this.name = this.constructor.name;
        this.errors = errors;
    }
}
class HttpError extends Error {
    constructor(status, text) {
        super(`Http geeft foutmelding: ${status} ${text}`);
        this.name = this.constructor.name;
        this.status = status;
        this.text = text;
    }
}
class JsonError extends Error {
    constructor(message) {
        super(`De JSON is onverwerkbaar: ${message}`);
        this.name = this.constructor.name;
    }
}
export {
    ValidationError,
    HttpError,
    JsonError,
}